<template>
  <v-card :variant="variant" class="pa-3" :color="color">
    <div v-if="title" class="text-subtitle-2 mb-2">{{ title }}</div>

    <!-- Cost Lines -->
    <div
      v-for="(line, index) in costLines"
      :key="index"
      class="d-flex justify-space-between mb-1"
      :class="line.class"
    >
      <span>{{ line.label }}</span>
      <span>{{ formatCost(line.amount) }} {{ line.currency || currency }}</span>
    </div>

    <!-- Divider before total -->
    <v-divider class="my-2"></v-divider>

    <!-- Total -->
    <div class="d-flex justify-space-between font-weight-bold" :class="totalClass">
      <span>{{ totalLabel }}</span>
      <span>{{ formatCost(total) }} {{ currency }}</span>
    </div>

    <!-- Payment Info Slot -->
    <slot name="payment-info"></slot>

    <!-- Additional Info Slot -->
    <slot name="additional-info"></slot>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OrderCostBreakdown',
  props: {
    title: {
      type: String,
      default: 'Cost Breakdown'
    },
    // Array of cost line items: { label: string, amount: number, currency?: string, class?: string }
    costLines: {
      type: Array,
      default: () => []
    },
    // Default currency for all items
    currency: {
      type: String,
      default: 'EUR'
    },
    // Total amount (if not provided, will be calculated from costLines)
    totalAmount: {
      type: Number,
      default: null
    },
    totalLabel: {
      type: String,
      default: 'TOTAL'
    },
    totalClass: {
      type: String,
      default: 'text-h6'
    },
    // Card styling
    variant: {
      type: String,
      default: 'tonal'
    },
    color: {
      type: String,
      default: 'primary'
    },
    // Number formatting
    decimals: {
      type: Number,
      default: 2
    }
  },
  computed: {
    total() {
      if (this.totalAmount !== null) {
        return this.totalAmount;
      }
      // Calculate from cost lines
      return this.costLines.reduce((sum, line) => sum + (parseFloat(line.amount) || 0), 0);
    }
  },
  methods: {
    formatCost(amount) {
      const num = parseFloat(amount) || 0;
      return num.toFixed(this.decimals);
    }
  }
});
</script>
